module.exports = __webpack_public_path__ + "img/Arif-Medianto.4ce28639.png";